// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1HAX0","requiredAsterisk":"Info_requiredAsterisk___PXlR"};